/* eslint-disable */
import { CustomersTO } from '../../../store/session/user-context/user-context.interface';

export default {
  items: [
    {
      customerNumber: '0001000000',
      customerName: 'Kimco N.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000001',
      customerName: 'Pomuni Trade',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000002',
      customerName: 'Delhaize Ets.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000003',
      customerName: 'Maison Amoroso S.A.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000010',
      customerName: 'Aldi Roeselare',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000011',
      customerName: 'Cust. Hierarchy test1',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000012',
      customerName: 'Aldi Erpe-Mere',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000013',
      customerName: 'Customer National Hierarchy3',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000017',
      customerName: 'Carrefour Belgium N.V. / S.A.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000020',
      customerName: 'Kimco N.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000025',
      customerName: 'ALDI Hoodkantoor (Rebate)',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000040',
      customerName: 'Pomuni Trade (NEW)',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000041',
      customerName: 'Pomuni Trade',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000050',
      customerName: 'ALDI Head Office Germany',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000051',
      customerName: 'Aldi Spain',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000055',
      customerName: 'Pomuni Trade (NEW)',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000070',
      customerName: 'Belgium Second Hand Buyer [SHB/32]',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000071',
      customerName: 'Pool Counter Lost [LOS/33]',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000075',
      customerName: 'TESTJDA',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000076',
      customerName: 'TESTJDA CSU BE',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000080',
      customerName: 'BelOrta cvba',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000106',
      customerName: 'Eco Veg BVBA',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000115',
      customerName: 'Pomuni Trade',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000119',
      customerName: 'Carrefour Belgium N.V. / S.A.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000122',
      customerName: 'Carrefour Belgium N.V. / S.A.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000140',
      customerName: 'Aardappelhandel De Rop N.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000141',
      customerName: 'Kaufland Polska Markety',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000150',
      customerName: 'Delhaize Le Lion/De Leeuw',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000151',
      customerName: 'N.V. Etn. Franz COLRUYT',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000153',
      customerName: 'Belgische Fruitveiling C.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000161',
      customerName: 'Makro N.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000171',
      customerName: 'Pool Stock Unknown',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: '0001000186',
      customerName: 'Collective stock unknown Belgium',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'DCP2000046',
      customerName: 'Departure Consolidation Point',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'FI.2000010',
      customerName: 'Frito Lay',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'FI.2000011',
      customerName: 'Groentekwekerij De Vries B.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'FI.2000012',
      customerName: 'Obstbauer Wedeking UG',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'FI.2000017',
      customerName: 'Agricola Jaifam S.L.U:',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'FI.2000035',
      customerName: 'Kimco N.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'FI.2000038',
      customerName: 'Maison Amoroso S.A.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'RE.2000013',
      customerName: 'Netto Coswig',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'RE.2000014',
      customerName: 'EDEKA FK Nord 161612',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'RE.2000015',
      customerName: 'Super Groente- en Fruitmarkt B.V.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'RE.2000016',
      customerName: 'Delhaize Ets.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'RE.2000018',
      customerName: 'Agro Verduras 2000, S.L.',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'RE.2000044',
      customerName: 'Kaufland Česká republika v.o.s. DC',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'SH2000033',
      customerName: 'Second Hand buyer',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'SL_BE11',
      customerName: 'Katelijne',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'SL_BE12',
      customerName: 'Roeselare',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'SL_BE13',
      customerName: 'Hoogstraten',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'SL_BE14',
      customerName: 'Halle (Colruyt)',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'SL_BE15',
      customerName: 'Zellik Delhaize',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'T_IM',
      customerName: 'Test JJE IM upload',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'T_IM_BE16',
      customerName: 'Test JJE IM upload',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'T_IM_BE17',
      customerName: 'Test JJE IM upload',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'T_SL',
      customerName: 'Test JJE SL upload',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'T_SL_BE16',
      customerName: 'Test JJE SL upload',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'T_SL_BE17',
      customerName: 'Test JJE SL upload',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
    {
      customerNumber: 'V300106',
      customerName: 'Bekuplast GmbH',
      salesOrganization: 'BE10',
      salesOffice: null,
      address: null,
    },
  ],
  totalItems: 59,
} as CustomersTO;
